import { Box, Flex, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import StrategyIncomeChart from './StrategyIncomeChart';

interface Props {
  chart: MultiItemsChart;
  currency: Currency;
}

const StrategyIncomeCard: FC<Props> = ({ chart, currency }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('strategyIncomeChart')}</GridHeading>
      <AppCard p="20px">
        <StrategyIncomeChart chart={chart} currency={currency} />
        <Flex flexWrap="wrap" alignItems="center" mt="5px" mb="15px">
          {Object.keys(chart.data).map((key) => {
            return (
              <Flex key={key} alignItems="center" mr="20px">
                <Box
                  w="15px"
                  h="15px"
                  mr="5px"
                  bgColor={chart.data[key].color}
                  borderRadius="50%"
                />
                <Text fontSize={FontSize.sm}>{key}</Text>
              </Flex>
            );
          })}
        </Flex>
      </AppCard>
    </>
  );
};

export default StrategyIncomeCard;
